import Vue from 'vue'
import App from './App'
import './assets/normalize.css'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router/router'
import store from './store'
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'
import WebSiteFooter from './components/webSiteFooter.vue'
import TagsView from './components/TagsView.vue'
import RightToolbar from "@/components/RightToolbar"
import TabView from "@/components/TabView"
import axios from 'axios'
import moment from 'moment'
import util from './common/util.js'
import VueWaypoint from 'vue-waypoint'
import Distpicker from 'v-distpicker'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import 'swiper/dist/css/swiper.css'
import './assets/icons/iconfont.css'
import './assets/styles/transition.css'
import 'babel-polyfill'
import animated from 'animate.css'
import * as echarts from 'echarts';
import { Popup } from 'vant';

Vue.use(Popup);
// Vue.use(Dialog);
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

Vue.prototype.util = util;
Vue.component('v-distpicker', Distpicker)
Vue.use(Element)
Vue.use(animated)
Vue.use(VueWaypoint)
Vue.component("Footer", Footer);
Vue.component("Header", Header);
// Vue.component("BreadCrumb", BreadCrumb);
Vue.component("TagsView", TagsView);
Vue.component("WebSiteFooter", WebSiteFooter);
Vue.component('RightToolbar', RightToolbar)
Vue.component("TabView", TabView);
// 中文简体
moment.locale('zh-cn');
Vue.filter('dateformat', (dataStr, pattern = 'YYYY-MM-DD') => {
  if (dataStr) {
    return moment(dataStr).format(pattern)
  }
})
Vue.filter('getDateFormat', (date) => {
  if (date) {
    var dateee = new Date(date).toJSON();
    return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  }
})
Vue.filter('cityFormat', (data) => {
  if (data.provCode) {
    return util.formAddress(data.provCode, data.cityCode, data.areaCode);
  }
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  var type = to.meta.type
  var token = window.sessionStorage.getItem('token')
  var userType = window.sessionStorage.getItem('userType')
  // 判断该路由是否需要登录权限
  if (type === 'login') {
    if (token) {
      if (to.matched.length === 0) {
        next('/404')
      }
      next()
    } else {
      if (userType == 0) {
        next('/login')
      }
      if (userType == 1) {
        next('/admin')
      }
      next('')
    }
  } else {
    if (to.matched.length === 0) {
      next('/404')
    }
    next()  // 确保一定要有next()被调用
  }
  var sysType = to.meta.sysType
  if (sysType === 'login') {
    if (token) {
      if (to.matched.length === 0) {
        next('/404')
      }
      next()
    } else {
      next('/admin')
    }
  } else {
    if (to.matched.length === 0) {
      next('/404')
    }
    next()  // 确保一定要有next()被调用
  }
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js